import { woodbridgeConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function WoodbridgePage() {
  return <CityPageTemplate config={woodbridgeConfig} />;
}